import appRoutes from "../routes/app";

export default [
  {
    path: "",
    name: "Home",
    component: require("../views/Home").default,
  },
  {
    path: "*",
    component: require("../views/App").default,
    children: appRoutes,
  },
];
